import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './ResetPassword.css';

export default function ResetPassword() {
  const { supabase, setRecovery, signOut } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [busy, setBusy]         = useState(false);
  const [error, setError]       = useState('');
  const [done, setDone]         = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return setError('Password must be at least 6 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setBusy(true); setError('');
    const { error } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (error) return setError(error.message);
    setDone(true);
  };

  return (
    <div className="reset-page">
      <div className="reset-card">
        <img src="/axion-logo.png" alt="Axion Mobility" className="reset-logo" />

        {done ? (
          <>
            <h2>Password Updated</h2>
            <p className="reset-lead">Your password has been changed successfully.</p>
            <button className="reset-submit" onClick={() => setRecovery(false)}>
              Continue to Dashboard
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            <h2>Set a New Password</h2>
            <p className="reset-lead">Choose a strong password for your Axion account.</p>
            {error && <div className="reset-error">{error}</div>}
            <input type="password" placeholder="New password (min 6 chars)" value={password}
              onChange={e => setPassword(e.target.value)} required autoFocus />
            <input type="password" placeholder="Confirm new password" value={confirm}
              onChange={e => setConfirm(e.target.value)} required />
            <button type="submit" className="reset-submit" disabled={busy}>
              {busy ? 'Updating…' : 'Update Password'}
            </button>
            <p className="reset-cancel" onClick={() => { setRecovery(false); signOut(); }}>
              Cancel
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
